/*
 * MANTEMI_CUSTOM-FILE (new file, not in stock Horizon). Loaded by snippets/product-grid.liquid.
 *
 * Collection and search grids show 2 cards per row on phones, so snippets/card-gallery.liquid ends the
 * card images' `sizes` with the 2-column width (50vw) instead of Horizon's 100vw. Shoppers can switch the
 * grid to the 1-column view (product-grid-view="mobile-single", results-list.js); then the cards are full
 * width and a 50vw image would look soft on high-density phones. This script swaps the last `sizes` entry
 * (the phone width) to 100vw in that view and back again in the 2-column view, so the browser picks a
 * suitable file in both. It also covers cards added later (infinite scroll, filters).
 *
 * Only the last entry is touched; the desktop/tablet breakpoints before it stay as rendered.
 */

const GRID_SELECTOR = '.product-grid[product-grid-view]';
const SINGLE_VIEW = 'mobile-single';
const FULL_WIDTH = '100vw';
const VW_ENTRY = /^\d+(\.\d+)?vw$/;

// Kept in memory, not in DOM attributes: Horizon's morph.js re-syncs attributes when filters re-render the grid.
/** @type {WeakMap<HTMLImageElement, string>} phone width as rendered by Liquid */
const renderedMobileSize = new WeakMap();
/** @type {WeakSet<Element>} grids that already have an observer */
const watchedGrids = new WeakSet();

/** @param {Element} grid */
function updateGridImageSizes(grid) {
  const single = grid.getAttribute('product-grid-view') === SINGLE_VIEW;

  for (const img of grid.querySelectorAll('img.product-media__image[sizes]')) {
    const parts = img.getAttribute('sizes').split(',');
    const last = parts[parts.length - 1].trim();

    // Remember the phone width as rendered by Liquid the first time we see the image.
    if (!renderedMobileSize.has(img)) {
      if (!VW_ENTRY.test(last)) continue;
      renderedMobileSize.set(img, last);
    }

    const wanted = single ? FULL_WIDTH : renderedMobileSize.get(img);
    if (last === wanted) continue;

    parts[parts.length - 1] = ` ${wanted}`;
    img.setAttribute('sizes', parts.join(','));
  }
}

/** Batches work into one pass per frame, so bursts of DOM changes cost a single update. */
const pending = new Set();
function schedule(grid) {
  if (pending.has(grid)) return;
  pending.add(grid);
  requestAnimationFrame(() => {
    pending.delete(grid);
    updateGridImageSizes(grid);
  });
}

/** @param {Element} grid */
function watchGrid(grid) {
  if (watchedGrids.has(grid)) return;
  watchedGrids.add(grid);
  updateGridImageSizes(grid);
  // View switches change the grid attribute; infinite scroll and filters add or replace cards.
  new MutationObserver(() => schedule(grid)).observe(grid, {
    attributes: true,
    attributeFilter: ['product-grid-view'],
    childList: true,
    subtree: true,
  });
}

document.querySelectorAll(GRID_SELECTOR).forEach(watchGrid);

// Filtering can render a new grid element; pick it up when it appears (checked at most once per frame).
let scanQueued = false;
new MutationObserver(() => {
  if (scanQueued) return;
  scanQueued = true;
  requestAnimationFrame(() => {
    scanQueued = false;
    document.querySelectorAll(GRID_SELECTOR).forEach(watchGrid);
  });
}).observe(document.querySelector('#ResultsList') ?? document.body, { childList: true, subtree: true });